import React from 'react';
import { Star } from 'lucide-react';
import type { UserItem } from '../../types/items';

interface ItemSelectionProps {
  items: UserItem[];
  selectedItems: UserItem[];
  onSelect: (items: UserItem[]) => void;
  maxSelections: number;
}

export function ItemSelection({ items, selectedItems, onSelect, maxSelections }: ItemSelectionProps) {
  const handleSelect = (item: UserItem) => {
    if (selectedItems.includes(item)) {
      onSelect(selectedItems.filter(i => i !== item));
    } else if (selectedItems.length < maxSelections) {
      onSelect([...selectedItems, item]);
    }
  };

  const rarityColors = {
    common: 'text-gray-400',
    uncommon: 'text-green-400',
    rare: 'text-blue-400',
    epic: 'text-purple-400',
    legendary: 'text-yellow-400'
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => handleSelect(item)}
          className={`p-4 rounded-lg text-left transition-all ${
            selectedItems.includes(item)
              ? 'bg-gradient-to-r from-yellow-600 to-amber-500'
              : 'bg-gray-800 hover:bg-gray-750'
          }`}
        >
          <div className="flex items-center gap-3">
            <img
              src={item.imageUrl}
              alt={item.name}
              className="w-12 h-12 rounded-lg object-cover"
            />
            <div>
              <div className="flex items-center gap-2">
                <span className="font-medium text-white">{item.name}</span>
                <Star className={`w-4 h-4 ${rarityColors[item.rarity]}`} />
              </div>
              <div className="text-sm text-gray-400">
                {item.type} • Qty: {item.quantity}
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}